import { Locale } from "@borealis/aurora";
import { Brand } from "../constants.js";

export const getLocaleByBrand = (brand: Brand): Locale => {
    switch (brand) {
        case Brand.DBA:
            return "da";
        case Brand.FINN:
            return "nb";
        case Brand.BLOCKET:
            return "sv";

        default:
            return "en";
    }
};
